import { createDocumentApi } from "./documents";
import type { ProjectDocumentApi } from "./documents";
import { createFoldersApi } from "./folders";
import type { ProjectFoldersApi } from "./folders";
import { createRfiApi } from "./rfi";
import type { ProjectRfiApi } from "./rfi";
import { createScheduleApi } from "./schedule";
import type { ProjectScheduleApi } from "./schedule";
import { createSubmittalApi } from "./submittals";
import type { ProjectSubmittalApi } from "./submittals";
import type { ProjectTransport } from "./transport";

export interface ProjectApis {
    documents: ProjectDocumentApi;
    folders: ProjectFoldersApi;
    rfis: ProjectRfiApi;
    schedule: ProjectScheduleApi;
    submittals: ProjectSubmittalApi;
}

/** Creates the complete project-domain API over one authenticated transport. */
export function createProjectApis(transport: ProjectTransport): ProjectApis {
    return {
        documents: createDocumentApi(transport),
        folders: createFoldersApi(transport),
        rfis: createRfiApi(transport),
        schedule: createScheduleApi(transport),
        submittals: createSubmittalApi(transport),
    };
}
